import React from 'react'

import ExportTemplateModal from '../export/ExportTemplateModal.js'
import {getColumnsInvoiceExport} from '../../utils/csvExport.js'
import t from '../../helpers/Languages.js'

const newExportTemplate = {
    name: '',
    columns: ['invoice._id', 'invoice.date', 'invoice.customer'],
    method: 'invoice'
}

const defaultColumns = [
    'invoice.date',
    'invoice.invoiceNumber',
    'invoice.customer',
    'invoice.customerDebtorCode',
    'invoice.description',
    'invoice.price',
    'invoice.status'
]

export default function ExportInvoicesModal(props) {
    const {reseller, onChange, open, onClickExport, onClose} = props

    return (
        <ExportTemplateModal
            title={t('exportInvoices')}
            open={open}
            onClose={onClose}
            templates={reseller.settings.administration.exportCsvTemplates || []}
            onSaveTemplates={(templates) => {
                reseller.settings.administration.exportCsvTemplates = templates
                onChange(reseller, 'administration.exportCsvTemplates')
            }}
            methods={[
                {value: 'invoice', title: t('exportPerInvoice')},
                {value: 'invoiceLine', title: t('exportPerInvoiceLine')}
            ]}
            getColumns={getColumnsInvoiceExport}
            defaultColumns={defaultColumns}
            newTemplate={newExportTemplate}
            onClickExport={onClickExport}
        />
    )
}
